/**
 * Returns the specified search parameter from the given URL
 * @param paramName - The name of the parameter to return
 * @param urlToSearch - The URL to retrieve the parameter from (optional)
 */
export const getSearchParam = (paramName: string, urlToSearch = window.location.href) => {
  const url = new URL(urlToSearch);
  const searchParams = url.searchParams;
  return searchParams.get(paramName);
};
